import './style.scss';

const LinkButton = (props) => {
  const {
    label,
    clickAction
  } = props;

  return (
    <button className='link-button' onClick={
      (e) => {
        e.preventDefault();
        if (typeof clickAction === 'function') {
          clickAction();
        }
      }
    }>{label}</button>
  );
};

export default LinkButton;